/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type IssueUrgency = 'Low' | 'Medium' | 'High';

export const IssueUrgency = {
    Low: 'Low' as IssueUrgency,
    Medium: 'Medium' as IssueUrgency,
    High: 'High' as IssueUrgency
};

